import HttpClientToken from '../../services/HttpClientToken';
import HttpClientFileToken from '../../services/HttpClientFileToken';

import { ConsultarIncidenteParams, ConsultaIncidenteResponse, defaultConsultaIncidente, DescargarIncidentesParams, IncidenteProps, IncidentesPendientesParams } from '../../interfaces/tribunal/IncidenteInterface';

export const IncidentesPendientes = ( params: IncidentesPendientesParams ) => {

    return new Promise<IncidenteProps[]>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){

            const { token } = data;

            HttpClientToken.post('/Api/incidente/IncidentesPendientes/', params, token)
            .then( ({ data } : { data : IncidenteProps[] } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( [] );
            });

        }

    });

}

export const ConsultarIncidentes = ( params: ConsultarIncidenteParams ) => {

    return new Promise<ConsultaIncidenteResponse>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem( 'data' ) ?? '{}' );

        if ( data ) {

            const { token } = data;

            HttpClientToken.post( '/Api/Incidente/ConsultarIncidentes', params, token )
            .then( ( { data }: { data: ConsultaIncidenteResponse } ) => {
                resolve( data );
            })
            .catch( () => {
                resolve( { ...defaultConsultaIncidente } );
            });

        }

    });

}

export const DescargarIncidentes = ( params: DescargarIncidentesParams ) => {

    return new Promise<Blob | null>( ( resolve ) => {

        const data = JSON.parse( window.localStorage.getItem( 'data' ) ?? '' );

        if ( data ) {

            const { token } = data;

            HttpClientFileToken.post( '/Api/Incidente/DescargarIncidentes', params, token )
            .then( ( resp: any ) => {
                resolve( resp.data );
            })
            .catch( () => {
                resolve( null );
            });

        }

    });

}
